<template>
  <Transition name="global-loading-fade">
    <div v-if="globalLoadingVisible" class="global-loading" role="status" aria-live="polite" aria-label="页面加载中">
      <div class="global-loading-progress"><i></i></div>
      <div class="global-loading-card">
        <div class="global-loading-spinner" aria-hidden="true"><i></i><span></span></div>
        <div><b>正在加载</b><small>请稍候，马上为你呈现</small></div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useAppContext } from '../../composables/appContext'

const { globalLoadingVisible } = useAppContext()
</script>
